import { Currency } from "types/currency";
import { VenuePriceTimeModule } from "types/time";

export const CURRENCIES: Array<Currency> = [
  {
    index: 1,
    name: "HKD",
    label: "$",
  },
  {
    index: 2,
    name: "RMB",
    label: "¥",
  },
  {
    index: 3,
    name: "CAD",
    label: "$",
  },
  {
    index: 4,
    name: "USD",
    label: "$",
  },
  {
    index: 5,
    name: "EUR",
    label: "€",
  },
  {
    index: 6,
    name: "GBP",
    label: "£",
  },
];

export const VENUE_PRICE_TIMES_MODULES: Array<VenuePriceTimeModule> = [
  {
    index: 0,
    name: "minutes",
  },
  {
    index: 1,
    name: "hours",
  },
];
